<template>
  <div class="dropdown" @mouseenter="openDropdown" @mouseleave="closeDropdown">
    <div class="dropdown-toggle" @click.stop="clickToggle">
      {{ selectedOption }}
      <i class="fas fa-chevron-down"></i>
    </div>
    <ul class="dropdown-menu" v-show="isOpen">
      <li v-for="option in options" :key="option.label" @click.stop="selectOption(option)">
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
    props: {
    options: {
      type: Array,
      default: () => {
        return [
            { value: '/ChemicalIndustry', label: '化工材料行业PLM' },
            { value: '/FoodBeverage', label: '食品饮料行业PLM' },
            { value: '/BeautyMakeup', label: '美妆日化行业PLM' },
        ]
      }
    },
    selectedOption: {
      type: String,
      default: '璞华易研PLM（流程行业）'
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    openDropdown() {
      this.isOpen = true
    },
    closeDropdown() {
      this.isOpen = false
    },
    clickToggle() {
      this.$emit('toggleClick')
      this.isOpen = true
    },
    selectOption(option) {
      this.$emit('changeHandle', option)
      this.isOpen = false
    },
  },
}
</script>
<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
  height: 4rem;
}
.dropdown-toggle {
  line-height: 4rem;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  color: #333;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 100;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border: .1rem solid #ccc;
  border-radius: .5rem;
  box-shadow: 0 .2rem .5rem rgba(0, 0, 0, 0.1);
}
.dropdown-menu li {
  min-width: 20rem;
  padding: 1rem 2rem;
  cursor: pointer;
}
.dropdown-menu li:hover {
  background-color: #f5f5f5;
}
</style>
